import { render, staticRenderFns } from "./ArticleGoods.vue?vue&type=template&id=94222db0&scoped=true&"
import script from "./ArticleGoods.vue?vue&type=script&lang=js&"
export * from "./ArticleGoods.vue?vue&type=script&lang=js&"
import style0 from "./ArticleGoods.vue?vue&type=style&index=0&id=94222db0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94222db0",
  null
  
)

export default component.exports